import AlertResponse from './alertResponse'; // Ajusta esta ruta según tu proyecto

export function showAlert({ msj, status, notificationSystemRef }){
    if (!notificationSystemRef.current) return;

    notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={status} />,
        level: status ? 'success' : 'error',
        position: 'br',
        autoDismiss: status ? 10 : 120,
    });
}


